export default "__VITE_ASSET__6bf83958__"